<div *ngIf="authService.LoginStatus">
  <header
    class="fixed top-0 left-0 right-0 bg-white border-b-1 border-[#E5E7EB] shadow-sm z-50 transition-all duration-300"
    [ngClass]="{'bg-black backdrop-blur-sm': true}">
    <div
      class="mx-auto w-full min-w-screen-m max-w-screen-2xl px-4 sm:px-6 md:px-8 lg:px-8 xl:px-16 2xl:px-24 3xl:px-16">
      <div class="flex items-center justify-between" style="height: 70px;">
        <!-- Left group: logo + menu -->
        <div class="flex items-center gap-8">
          <img id="header-logo" src="assets/images/logo-black.svg" alt="Logo" class="h-14" style="max-height: 64px;" />
          <nav class="flex items-center gap-6 transform origin-left cursor-pointer">
            <a id="header-transactions-link" routerLink="/transactions" routerLinkActive="active-link"
              #transactionsRla="routerLinkActive" [ngClass]="transactionsRla.isActive ? 'font-bold' : 'font-normal'"
              class="text-gray-900 text-xl leading-5 transition-colors duration-200 cursor-pointer"
              [routerLinkActiveOptions]="{ exact: true }">
              Transactions
            </a>
            <span class="h-6 border-l border-[#000000]"></span>
            <a id="header-faq-link" routerLink="/faqs" routerLinkActive="active-link" #faqsRla="routerLinkActive"
              [ngClass]="faqsRla.isActive ? 'font-bold' : 'font-normal'"
              class="text-gray-900 text-xl leading-5 transition-colors duration-200 cursor-pointer"
              [routerLinkActiveOptions]="{ exact: true }">
              FAQs
            </a>
          </nav>
        </div>

        <!-- Right group: user section -->
        <div class="flex flex-col items-end gap-y-4 origin-right">
          <div class="relative">
            <div class="flex items-center gap-2 px-3 py-2 rounded-full cursor-pointer">
              <!-- Initials -->
              <span data-testid="avatar-initials"
                class="inline-flex items-center justify-center h-7 w-7 rounded-full bg-[#D9D9D9] font-normal text-sm"
                [ngStyle]="{
          'color': '#000',
          'font-family': 'Inter',
          'font-style': 'normal',
          'font-weight': '400',
          'line-height': 'normal'
        }">
                {{ getInitials(username) }}
              </span>

              <!-- Full name -->
              <span class="hidden sm:inline text-xl" [ngStyle]="{
        'color': '#3B3B3B',
        'font-family': 'Inter',
        'font-style': 'normal',
        'font-weight': '400',
        'line-height': 'normal'
      }">
                {{ username }}
              </span>

              <!-- Clickable dropdown icon -->
              <i id="header-profile-dropdown" class="pi pi-chevron-down w-4 h-4 cursor-pointer"
                data-testid="dropdown-toggle" (click)="toggleDropdown()"></i>

            </div>

            <!-- Dropdown: shown when isDropdownOpen is true -->
            <div *ngIf="isDropdownOpen"
              class="absolute right-0 w-40 bg-white border border-gray-200 rounded shadow-lg z-10">
              <button id="header-logout-button" (click)="logout()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 break-words flex items-center gap-2 cursor-pointer"
                [ngStyle]="{
          'color': '#3B3B3B',
          'font-size': '12px',
          'font-family': 'Inter',
          'font-weight': '400'
        }">
                <span class="pi pi-sign-out"></span>
                <span class="text-base">Log Out</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </header>
</div>